<div class="flex gap-6 justify-start items-start">
  <div *ngIf="!isPriceEmpty" class="flex flex-col justify-start items-start">

    <div *ngIf="!isFromPrice" class="text-grey-3 font-medium text-sm">Pris</div>
    <div *ngIf="isFromPrice" class="text-grey-3 font-medium text-sm whitespace-nowrap">Pris från</div>
    <div class="text-apricot-1 font-bold text-base whitespace-nowrap">{{ formattedPrice }}
      <app-ui-icon #tooltip="matTooltip"
                (click)="tooltip.show()"
                *ngIf="priceDescription && !isPriceEmpty"
                class="booking-price-tooltip test-booking-price-tooltip"
                color="var(--apricot-1)"
                matTooltip="{{ priceDescription }}"
                matTooltipClass="varden-tooltip"
                matTooltipPosition="above"
                name="info"
                size="sm"
      ></app-ui-icon>
    </div>
  </div>

  <div *ngIf="isPriceEmpty && priceDescription" class="flex flex-col justify-start items-start">
    <div class="text-grey-3 font-medium text-sm">Pris</div>
    <div class="text-apricot-1 font-medium text-base">{{ priceDescription }}</div>
  </div>
  <div *ngIf="activityLength" class="flex flex-col justify-start items-start">
    <div class="text-grey-3 font-medium text-sm">Längd</div>
    <div class="text-apricot-1 font-medium text-base whitespace-nowrap">{{ activityLength }} min</div>
  </div>
</div>

